import { JsonProperty } from '~app/shared/json-mapper';
import { TenantModel } from '~app/core/auth';

export class AccountTenantAddressModel {
  @JsonProperty('_id')
  id: string = void 0;
  @JsonProperty('address')
  street: string = void 0;
  city: string = void 0;
  country: string = void 0;
  postalCode: string = void 0;
  @JsonProperty('state')
  region: string = void 0;
}

export class AccountTenantModel extends TenantModel {
  @JsonProperty({ type: AccountTenantAddressModel })
  address: AccountTenantAddressModel = void 0;
  updatedAt: string = void 0;
  createdAt: string = void 0;
}

export class AccountModel {
  @JsonProperty('_id')
  id: string = void 0;
  email: string = void 0;
  @JsonProperty({ excludeToJson: true, type: AccountTenantModel })
  tenants: AccountTenantModel[] = [];
  @JsonProperty('zoneinfo')
  timeZone = 'America/New_York';
  locale = 'en-US';
  updatedAt: string = void 0;
  createdAt: string = void 0;
}
